module.exports = __webpack_public_path__ + "img/公司愿景banner.b52216b4.png";